module.exports = __webpack_public_path__ + "static/media/webmin.3a432399.svg";